// Models
// Utilities
import { Temporal } from "temporal-polyfill-lite";
/**
 * Represents a recurrence pattern calculator
 */ export class RecurrenceCalculator {
    get interval() {
        return this.schedule.pattern.interval;
    }
    /**
     * Get the period dates between the start and end dates.
     *
     * @description The periods will be represented by arbitrary dates within the patterned type.
     * These dates will be determined by the start parameter.
     *
     * @example For a weekly pattern the periods will be any date within each week, this could be a
     * series of tuesdays etc. Then add 1 week to calculate the next period date.
     *
     * @example For a monthly pattern the periods will be any date within each month, this could be
     * a series of the 12th day in each month etc. Then add 1 month to calculate the next period date.
     *
     * @param start Start date of the window.
     * @param end End date of the window.
     * @returns The period dates between the start and end dates. Empty array if no periods found or end is before start.
     */ getPeriodsBetween(start, end) {
        let currentPeriod = Temporal.PlainDate.from(start);
        const periods = [];
        while(this.isSameOrBefore(currentPeriod, end)){
            periods.push(currentPeriod);
            currentPeriod = currentPeriod.add(this.periodPattern);
        }
        return periods;
    }
    constructor(schedule, patternStartDateAsInstant, occurrenceIndex, periodPattern){
        this.schedule = schedule;
        this.occurrenceIndex = occurrenceIndex;
        this.periodPattern = periodPattern;
        this.patternStartDate = patternStartDateAsInstant.toZonedDateTimeISO("UTC").toPlainDate();
    }
}
